/**
 * Helper constants for determining the current environment.
 */

export const IS_DEV = process.env.NODE_ENV === "development";
// @ts-ignore
export const IS_STAGING = process.env.NODE_ENV === "staging";
export const IS_LOCAL = IS_DEV && !IS_STAGING;
export const IS_PROD = process.env.NODE_ENV === "production";
export const IS_TEST = process.env.NODE_ENV === "test";

export const IS_STORYBOOK = process.env.STORYBOOK === "true";

export const IS_EDGE_RUNTIME = process.env.NEXT_RUNTIME === "edge";
export const IS_NODEJS_RUNTIME = process.env.NEXT_RUNTIME === "nodejs";

export const ENVIRONMENT_STRING = process.env.NEXT_PUBLIC_ENVIRONMENT_STRING;
